import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const Business: AppRouteModule = {
  path: '/groupRefund',
  name: 'GroupRefund',
  identify: 'groupRefundDetails',
  component: LAYOUT,
  redirect: '/groupRefund/details',
  meta: {
    icon: 'icon-park-outline:volume-notice',
    title: '团购补贴返款明细',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    {
      path: 'details',
      name: 'GroupRefundDetails',
      identify: 'groupRefundDetails',
      component: () => import('@/views/groupRefundMange/groupList/index.vue'),
      meta: {
        title: '团购补贴返款明细',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/groupRefund',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};

export default Business;
